export default [
    {
        type: 'textarea',
        input: true,
        key: 'template',
        label: 'Dot Value Template',
        editor: 'ace',
        as: 'html',
        rows: 10,
        weight: 18,
        tooltip: 'The HTML template for displaying dots\' values in preview mode (View Tab, generated PDF)',
        description: 'Four available variables. "dot" is the data of the dot, "index" is the index of the dot (indexes start from \'0\'), "components" is an array of components of the form associated with the dot and "instance" is an instance of the Tagpad.',
    },
];
